import * as tslib_1 from "tslib";
import { jsonMember, jsonObject } from "typedjson";
let DxControlPointChainGeneration = class DxControlPointChainGeneration {
    constructor(fields) {
        if (fields)
            Object.assign(this, fields);
    }
};
tslib_1.__decorate([
    jsonMember({ constructor: Date, isRequired: true }),
    tslib_1.__metadata("design:type", Date)
], DxControlPointChainGeneration.prototype, "baseDate", void 0);
tslib_1.__decorate([
    jsonMember({ constructor: Object, isRequired: true }),
    tslib_1.__metadata("design:type", Object)
], DxControlPointChainGeneration.prototype, "businessObject", void 0);
tslib_1.__decorate([
    jsonMember({ constructor: Number, isRequired: true }),
    tslib_1.__metadata("design:type", Number)
], DxControlPointChainGeneration.prototype, "chainPatternId", void 0);
DxControlPointChainGeneration = tslib_1.__decorate([
    jsonObject(),
    tslib_1.__metadata("design:paramtypes", [Object])
], DxControlPointChainGeneration);
export { DxControlPointChainGeneration };
